export interface ProductSupplierQuote {
  id: string;
  product_id: string;
  product_type_id: string | null;
  product_type_text: string | null;
  supplier_name: string;
  price: number;
  quote_time: string;
  quantity: number;
  note: string | null;
  created_at: string;
  created_by?: string | null;
  modified_at?: string | null;
  modified_by?: string | null;
}

export interface CreateSupplierQuotePayload {
  product_id: string;
  product_type_id?: string | null;
  product_type_text?: string | null;
  supplier_name: string;
  price: number;
  quote_time: string; // ISO 8601
  quantity: number;
  note?: string | null;
}

export interface UpdateSupplierQuotePayload {
  product_type_id?: string | null;
  product_type_text?: string | null;
  supplier_name?: string;
  price?: number;
  quote_time?: string;
  quantity?: number;
  note?: string | null;
}

export interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data?: T;
}

export interface PagedSupplierQuotesResponse {
  collection: ProductSupplierQuote[];
  total: number;
  pagesize: number;
  pageIndex: number;
}

export interface GetProductSupplierQuotesParams {
  page?: number;
  pageSize?: number;
  sorts?: string;
  filters?: string;
  productTypeId?: string;
  supplier_name?: string;
  quote_time?: string | Date;
}

/**
 * Format quantity display:
 * - If integer (10.0, 10.00) -> displays "10"
 * - If fractional (10.5, 12.75) -> displays "10.5", "12.75"
 */
export function formatQuantity(qty: number | null | undefined): string {
  if (qty == null || isNaN(qty)) return '0';
  if (qty % 1 === 0) {
    return qty.toFixed(0);
  }
  return parseFloat(qty.toFixed(4)).toString();
}
